import { useSession } from "./lib/useSession";
import Login from "./screens/Login";
import Callback from "./screens/Callback";
import Connect from "./screens/Connect";
import AppShell from "./screens/AppShell";

// Minimal path-based router. The Worker serves index.html for every non-/api
// path (SPA fallback), so we branch on window.location.pathname:
//   /auth/callback  → complete the OAuth code exchange
//   /login          → sign-in screen
//   everything else → protected app (redirect to /login when unauthenticated)
export default function App() {
  const path = window.location.pathname;
  const { loading, session } = useSession();

  // The callback route runs its own exchange regardless of session state.
  if (path === "/auth/callback") {
    return <Callback />;
  }

  // The MCP OAuth consent route manages its own session state (sign in if
  // needed, then authorize) — render it before the app's auth gate.
  if (path === "/connect") {
    return <Connect />;
  }

  // Safety net: Supabase may land on the app root (its configured Site URL)
  // with a PKCE `?code=` instead of /auth/callback. Run the same code-exchange
  // the callback does so login still completes. (The owner is also fixing the
  // Supabase Site URL; this guards against a misconfiguration either way.)
  if (new URLSearchParams(window.location.search).has("code")) {
    return <Callback />;
  }

  if (loading) {
    return (
      <div className="auth">
        <div className="auth-card">
          <div className="auth-logo">citada</div>
          <div className="spinner" />
        </div>
      </div>
    );
  }

  if (!session) {
    // Keep the URL honest so a refresh stays on the login screen.
    if (path !== "/login") {
      window.history.replaceState(null, "", "/login");
    }
    return <Login />;
  }

  // Authenticated: if we're sitting on /login (or /auth/callback fell through),
  // normalise to the app root.
  if (path === "/login") {
    window.history.replaceState(null, "", "/");
  }
  return <AppShell session={session} />;
}
